import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if this.model.canLoadMore}}
  {{hide-application-footer}}
{{/if}}

{{body-class "user-notifications-page"}}

<div class="user-navigation user-navigation-secondary">
  <HorizontalOverflowNav @ariaLabel="User secondary - notifications">
    <DNavigationItem
      @route="userNotifications.index"
      @ariaCurrentContext="subNav"
      class="user-nav__notifications-all"
    >
      {{d-icon "bell"}}
      <span>{{i18n "user.filters.all"}}</span>
    </DNavigationItem>

    <DNavigationItem
      @route="userNotifications.responses"
      @ariaCurrentContext="subNav"
      class="user-nav__notifications-responses"
    >
      {{d-icon "reply"}}
      <span>{{i18n "user_action_groups.6"}}</span>
    </DNavigationItem>

    <DNavigationItem
      @route="userNotifications.likesReceived"
      @ariaCurrentContext="subNav"
      class="user-nav__notifications-likes"
    >
      {{d-icon "heart"}}
      <span>{{i18n "user_action_groups.2"}}</span>
    </DNavigationItem>

    {{#if this.siteSettings.enable_mentions}}
      <DNavigationItem
        @route="userNotifications.mentions"
        @ariaCurrentContext="subNav"
        class="user-nav__notifications-mentions"
      >
        {{d-icon "at"}}
        <span>{{i18n "user_action_groups.7"}}</span>
      </DNavigationItem>
    {{/if}}

    <DNavigationItem
      @route="userNotifications.edits"
      @ariaCurrentContext="subNav"
      class="user-nav__notifications-edits"
    >
      {{d-icon "pencil-alt"}}
      <span>{{i18n "user_action_groups.11"}}</span>
    </DNavigationItem>

    <DNavigationItem
      @route="userNotifications.links"
      @ariaCurrentContext="subNav"
      class="user-nav__notifications-links"
    >
      {{d-icon "link"}}
      <span>{{i18n "user_action_groups.17"}}</span>
    </DNavigationItem>

    <PluginOutlet
      @name="user-notifications-bottom"
      @connectorTagName="li"
      @outletArgs={{hash model=this.model}}
    />

  </HorizontalOverflowNav>

  {{#if this.model}}
    <div class="navigation-controls">
      <DButton
        @title="user.dismiss_notifications_tooltip"
        @action={{action "resetNew"}}
        @label="user.dismiss_notifications"
        @icon="check"
        @disabled={{this.allNotificationsRead}}
        class="btn-default dismiss-notifications"
      />
    </div>
  {{/if}}
</div>

<section class="user-content" id="user-content">
  <LoadMore
    @selector=".user-stream .notification"
    @action={{action "loadMore"}}
    class="notification-history user-stream"
  >
    {{outlet}}
    <ConditionalLoadingSpinner @condition={{this.model.loadingMore}} />
  </LoadMore>
</section>
*/
{
  "id": "DckYy3cr",
  "block": "[[[41,[30,0,[\"model\",\"canLoadMore\"]],[[[1,\"  \"],[1,[34,1]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[1,[28,[35,2],[\"user-notifications-page\"],null]],[1,\"\\n\\n\"],[10,0],[14,0,\"user-navigation user-navigation-secondary\"],[12],[1,\"\\n  \"],[8,[39,3],null,[[\"@ariaLabel\"],[\"User secondary - notifications\"]],[[\"default\"],[[[[1,\"\\n    \"],[8,[39,4],[[24,0,\"user-nav__notifications-all\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"userNotifications.index\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,5],[\"bell\"],null]],[1,\"\\n      \"],[10,1],[12],[1,[28,[35,6],[\"user.filters.all\"],null]],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[39,4],[[24,0,\"user-nav__notifications-responses\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"userNotifications.responses\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,5],[\"reply\"],null]],[1,\"\\n      \"],[10,1],[12],[1,[28,[35,6],[\"user_action_groups.6\"],null]],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[39,4],[[24,0,\"user-nav__notifications-likes\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"userNotifications.likesReceived\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,5],[\"heart\"],null]],[1,\"\\n      \"],[10,1],[12],[1,[28,[35,6],[\"user_action_groups.2\"],null]],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n\"],[41,[30,0,[\"siteSettings\",\"enable_mentions\"]],[[[1,\"      \"],[8,[39,4],[[24,0,\"user-nav__notifications-mentions\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"userNotifications.mentions\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,5],[\"at\"],null]],[1,\"\\n        \"],[10,1],[12],[1,[28,[35,6],[\"user_action_groups.7\"],null]],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[8,[39,4],[[24,0,\"user-nav__notifications-edits\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"userNotifications.edits\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,5],[\"pencil-alt\"],null]],[1,\"\\n      \"],[10,1],[12],[1,[28,[35,6],[\"user_action_groups.11\"],null]],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[39,4],[[24,0,\"user-nav__notifications-links\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"userNotifications.links\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,5],[\"link\"],null]],[1,\"\\n      \"],[10,1],[12],[1,[28,[35,6],[\"user_action_groups.17\"],null]],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[39,7],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"user-notifications-bottom\",\"li\",[28,[37,8],null,[[\"model\"],[[30,0,[\"model\"]]]]]]],null],[1,\"\\n\\n  \"]],[]]]]],[1,\"\\n\\n\"],[41,[30,0,[\"model\"]],[[[1,\"    \"],[10,0],[14,0,\"navigation-controls\"],[12],[1,\"\\n      \"],[8,[39,9],[[24,0,\"btn-default dismiss-notifications\"]],[[\"@title\",\"@action\",\"@label\",\"@icon\",\"@disabled\"],[\"user.dismiss_notifications_tooltip\",[28,[37,10],[[30,0],\"resetNew\"],null],\"user.dismiss_notifications\",\"check\",[30,0,[\"allNotificationsRead\"]]]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[13],[1,\"\\n\\n\"],[10,\"section\"],[14,0,\"user-content\"],[14,1,\"user-content\"],[12],[1,\"\\n  \"],[8,[39,11],[[24,0,\"notification-history user-stream\"]],[[\"@selector\",\"@action\"],[\".user-stream .notification\",[28,[37,10],[[30,0],\"loadMore\"],null]]],[[\"default\"],[[[[1,\"\\n    \"],[46,[28,[37,13],null,null],null,null,null],[1,\"\\n    \"],[8,[39,14],null,[[\"@condition\"],[[30,0,[\"model\",\"loadingMore\"]]]],null],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"],[13]],[],false,[\"if\",\"hide-application-footer\",\"body-class\",\"horizontal-overflow-nav\",\"d-navigation-item\",\"d-icon\",\"i18n\",\"plugin-outlet\",\"hash\",\"d-button\",\"action\",\"load-more\",\"component\",\"-outlet\",\"conditional-loading-spinner\"]]",
  "moduleName": "discourse/templates/user/notifications.hbs",
  "isStrictMode": false
});